import {IconDefinition} from "@fortawesome/free-solid-svg-icons";

export const AllIcons: IconDefinition[] = [
    {
        prefix: 'workspace',
        iconName: 'teams',
        icon: [
            50,
            50,
            [],
            'U+E002',
            `M 27.5 5 C 24.08 5 21.269531 7.64 21.019531 11 L 24 11 C 26.76 11 29 13.24 29 16 L 29 17.820312 C 31.87 17.150312 34 14.57 34 11.5 C 34 7.91 31.09 5 27.5 5 z M 42.5 9 A 4.5 4.5 0 0 0 42.5 18 A 4.5 4.5 0 0 0 42.5 9 z M 6 13 C 4.346 13 3 14.346 3 16 L 3 34 C 3 35.654 4.346 37 6 37 L 24 37 C 25.654 37 27 35.654 27 34 L 27 16 C 27 14.346 25.654 13 24 13 L 6 13 z M 10 19 L 20 19 L 20 21 L 16 21 L 16 31 L 14 31 L 14 21 L 10 21 L 10 19 z M 29 21 L 29 34 C 29 36.76 26.76 39 24 39 L 18.199219 39 C 18.599219 40.96 19.569688 42.710313 20.929688 44.070312 C 22.739688 45.880312 25.24 47 28 47 C 33.52 47 38 42.52 38 37 L 38 21 L 29 21 z M 40 21 L 40 37 C 40 37.82 39.919531 38.620625 39.769531 39.390625 C 40.599531 39.780625 41.52 40 42.5 40 C 46.09 40 49 37.09 49 33.5 L 49 21 L 40 21 z`,
        ],
    } as any,
    {
        prefix: 'workspace',
        iconName: 'uctl',
        icon: [
            31,
            32,
            [],
            'U+E002',
            `M19.0123 0C18.7914 0 18.6123 0.179086 18.6123 0.4V8.52401H14.7977C13.9276 8.52401 13.4726 9.55834 14.0606 10.1997L20.6814 17.4223C21.0905 17.8686 21.7992 17.8519 22.1868 17.3868L28.2055 10.1642C28.7482 9.51286 28.2851 8.52401 27.4373 8.52401H23.4831V0.4C23.4831 0.179086 23.304 0 23.0831 0H19.0123ZM12.2713 22.1521L3.02706 31.3964C2.58122 31.8422 1.8584 31.8422 1.41261 31.3964L0.334369 30.3182C-0.11071 29.8731 -0.111566 29.1517 0.332467 28.7056L7.65875 21.3449L0.332514 13.9842C-0.111519 13.5381 -0.110663 12.8168 0.334417 12.3717L1.41261 11.2935C1.85845 10.8476 2.58127 10.8476 3.02706 11.2935L12.2713 20.5377C12.7171 20.9835 12.7171 21.7063 12.2713 22.1521ZM30.4426 30.8582V29.3361C30.4426 28.7056 29.9315 28.1945 29.301 28.1945H14.8408C14.2103 28.1945 13.6992 28.7056 13.6992 29.3361V30.8582C13.6992 31.4887 14.2103 31.9998 14.8408 31.9998H29.301C29.9315 31.9998 30.4426 31.4887 30.4426 30.8582Z`,
        ],
    } as any,
    {
        prefix: 'workspace',
        iconName: 'support',
        icon: [
            28,
            28,
            [],
            'U+E002',
            `M22.915 8.1c-.312.104-.515.331-.515.72v7.98c0 .848.86 1.098 1.813 1.017-.253 2.306-1.736 4.763-3.563 5.983-.546.364-1.081.591-1.604.7H18.9l-.745-.186a3.15 3.15 0 1 0-.088 1.446H20.3v-.01c.628-.03 1.18-.552 1.854-1.19.2-.188.41-.387.636-.586 1.825-1.967 3.054-4.274 2.997-6.567a3.08 3.08 0 0 0 .463-.257c1.284-.883 1.4-2.642 1.4-4.2 0-1.558-.816-3.317-2.1-4.2a3.66 3.66 0 0 0-.195-.125C23.809 3.629 19.154 0 13.65 0 8.19 0 3.566 3.571 1.983 8.505.767 9.41 0 11.109 0 12.62c0 1.558.116 3.316 1.4 4.199 1.126.774 3.85 1.159 3.85-.35V8.49c0-.457-.28-.69-.689-.765A10.15 10.15 0 0 1 13.65 2.1c4.127 0 7.678 2.463 9.265 6Z`]
    } as any,
    {
        prefix: 'workspace',
        iconName: 'folder',
        icon: [
            30,
            30,
            [],
            'U+E002',
            `M11.88 0H0v27h30.24V4.32H16.056L11.88 0Z`
        ],
    } as any,
    {
        prefix: 'workspace',
        iconName: 'assignment',
        icon: [
            30,
            30,
            [],
            'U+E002',
            `M28.793.013c-1.258.09-7.966.762-11.945 4.91C13.612 8.296 13.08 12.975 13.01 15H9.047a1 1 0 0 0-.839 1.545l5.952 9.164a1 1 0 0 0 1.678 0l5.952-9.164A1 1 0 0 0 20.952 15H16.7c-.171-1.764-.13-5.502 2.706-8.23 3.106-2.99 8.168-2.15 9.344-1.903a.208.208 0 0 0 .25-.202V.21a.193.193 0 0 0-.207-.196ZM11.148 10H3.615v18.382H25V12.8s.705-1.3 1.9-1.3c1.058 0 1.754 1.018 1.9 1.252V32H0V6.4h11.149s1.266.57 1.266 1.8-1.267 1.8-1.267 1.8Z`
        ],
    } as any,

    {
        prefix: 'workspace',
        iconName: 'managedService',
        icon: [
            30,
            30,
            [],
            'U+E002',
            `M2 26.571V7h28v19.571H2ZM2 0a2 2 0 0 0-2 2v24.571a2 2 0 0 0 2 2h28a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2Zm18.044 12.044a1.202 1.202 0 0 0-.684-1.598 1.3 1.3 0 0 0-1.651.707l-4.902 11.694c-.267.637.04 1.353.685 1.599a1.3 1.3 0 0 0 1.65-.707l4.902-11.695Zm8.525 5.797c.27-.555.13-1.256-.357-1.641l-4.418-3.506c-.536-.426-1.29-.305-1.683.269-.394.574-.278 1.384.258 1.81l3.416 2.71-3.6 3.541a1.363 1.363 0 0 0-.08 1.828c.448.526 1.21.56 1.702.077l4.38-4.307a1.33 1.33 0 0 0 .382-.78ZM10.498 23.05a1.322 1.322 0 0 1-1.805.11l-4.677-3.942a1.225 1.225 0 0 1-.2-.17 1.182 1.182 0 0 1-.128-1.7c.034-.05.073-.098.115-.144L8.23 12.46a1.146 1.146 0 0 1 1.703.002c.47.505.47 1.325-.002 1.83l-3.472 3.722 3.931 3.314c.529.445.577 1.217.109 1.723Z`]
    } as any,
    {
        prefix: 'workspace',
        iconName: 'configMap',
        icon: [
            30,
            30,
            [],
            'U+E002',
            `M0 1a1 1 0 0 1 1-1h10.387a1 1 0 0 1 1 1v11.42a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1Zm0 15.484a1 1 0 0 1 1-1h10.387a1 1 0 0 1 1 1v11.42a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1v-11.42ZM15.452 0a1 1 0 0 0-1 1v6.258a1 1 0 0 0 1 1H31a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1H15.452Zm-1 11.323a1 1 0 0 1 1-1H31a1 1 0 0 1 1 1v6.258a1 1 0 0 1-1 1H15.452a1 1 0 0 1-1-1v-6.258Zm1 9.322a1 1 0 0 0-1 1v6.258a1 1 0 0 0 1 1H31a1 1 0 0 0 1-1v-6.258a1 1 0 0 0-1-1H15.452Z`]
    } as any,
    {
        prefix: 'workspace',
        iconName: 'tableSettings',
        icon: [
            30,
            30,
            [],
            'U+E002',
            `M2 2h21v4H2V2Zm0 6v4h8.924a1.963 1.963 0 0 0-.028 1.465l.198.535H2v4h7.34l-.398.184A1.974 1.974 0 0 0 7.78 20H2v4h9.56c.052.329.023.674-.1 1.007l-.366.993H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h21a2 2 0 0 1 2 2v9.463a2 2 0 0 1-2-.371V8h-2.077a2.04 2.04 0 0 0-1.846 0H2Zm17.04 3.254c.283-.956 1.637-.956 1.92 0l.756 2.57a1 1 0 0 0 1.438.595l2.352-1.281c.875-.477 1.833.48 1.356 1.356l-1.28 2.352a1 1 0 0 0 .595 1.438l2.569.757c.956.282.956 1.636 0 1.918l-2.57.757a1 1 0 0 0-.595 1.438l1.281 2.352c.477.875-.48 1.833-1.356 1.356l-2.352-1.28a1 1 0 0 0-1.438.595l-.757 2.569c-.282.956-1.636.956-1.918 0l-.757-2.57a1 1 0 0 0-1.438-.595l-2.352 1.281c-.876.477-1.833-.48-1.356-1.356l1.28-2.352a1 1 0 0 0-.595-1.438l-2.569-.757c-.956-.282-.956-1.636 0-1.918l2.57-.757a1 1 0 0 0 .595-1.438l-1.281-2.352c-.477-.875.48-1.833 1.356-1.356l2.352 1.28a1 1 0 0 0 1.438-.595l.757-2.569ZM23 20a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z`]
    } as any,
    {
        prefix: 'workspace',
        iconName: 'yaml',
        icon: [
            30,
            30,
            [],
            'U+E002',
            `M11.698 0H15v7.6c0 .22.18.4.4.4h7.997v21.753a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h9.698ZM4.376 11.266h3.928l3.075 6.087h.128l3.075-6.087h3.928l-5.32 9.688v4.858H9.696v-4.858l-5.32-9.688ZM17.658 1.057a.4.4 0 0 0-.658.305V5.6c0 .22.18.4.4.4h5.008a.4.4 0 0 0 .258-.705l-5.008-4.238Z`]
    } as any,
    {
        prefix: 'workspace',
        iconName: 'secret',
        icon: [
            30,
            30,
            [],
            'U+E002',
            `M7.5 8.5a8.5 8.5 0 0 1 17 0V11H26a2 2 0 0 1 2 2v4h4v11h-4v2a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-2H0V17h4v-4a2 2 0 0 1 2-2h1.5V8.5ZM20.7 11h-9.6V8.4a4.8 4.8 0 1 1 9.6 0V11ZM1 27v-9h30v9H1Zm5.521-1.273.133-2.061-1.726 1.156-.714-1.257 1.86-.906-1.86-.905.714-1.258 1.726 1.156-.133-2.061h1.433l-.139 2.061 1.726-1.156.714 1.258-1.854.905 1.854.906-.714 1.257-1.726-1.156.139 2.061H6.52Zm8.467 0 .133-2.061-1.726 1.156-.714-1.257 1.86-.906-1.86-.905.714-1.258 1.726 1.156-.133-2.061h1.433l-.139 2.061 1.726-1.156.714 1.258-1.854.905 1.854.906-.714 1.257-1.726-1.156.139 2.061h-1.433Zm8.466 0 .134-2.061-1.726 1.156-.714-1.257 1.86-.906-1.86-.905.714-1.258 1.726 1.156-.134-2.061h1.433l-.138 2.061 1.726-1.156.714 1.258-1.854.905 1.854.906-.714 1.257-1.726-1.156.138 2.061h-1.433Z`]
    } as any,
    {
        prefix: 'workspace',
        iconName: 'roleBinding',
        icon: [
            30,
            30,
            [],
            'U+E002',
            `M13 0H3a2 2 0 0 0-2 2v7.034a6.5 6.5 0 1 1 8.173 9.392C12.66 19.57 15.33 22.89 15.957 27h2.711A9.504 9.504 0 0 1 21.5 10.483V8h-8.1a.4.4 0 0 1-.4-.4V0ZM1 15.966a6.528 6.528 0 0 0 2.827 2.46A9.127 9.127 0 0 0 1 19.96v-3.993ZM14.5.466a.4.4 0 0 1 .683-.283l5.634 5.634a.4.4 0 0 1-.283.683H14.9a.4.4 0 0 1-.4-.4V.466ZM24.5 27a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15Zm-4.13-7.793a.82.82 0 0 0 .169 1.216l2.205 1.533a.82.82 0 0 0 .16.153l.186.136a.93.93 0 0 0 1.232-.142l3.42-3.961a.764.764 0 0 0-.131-1.135l-.187-.136a.93.93 0 0 0-1.232.141l-2.774 3.215-1.73-1.202a.998.998 0 0 0-1.318.182Zm-7.102 8.101c-.465-3.92-3.258-6.933-6.634-6.933-3.376 0-6.17 3.013-6.634 6.933h13.268ZM6.5 17a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Z`]
    } as any,
    {
        prefix: 'workspace',
        iconName: 'serviceInstance',
        icon: [
            30,
            30,
            [],
            'U+E002',
            `M.236 4.957a.09.09 0 0 0-.049.137l-.064-.025A.09.09 0 0 0 0 5.152v17.751a.09.09 0 0 0 .055.083l15.32 6.445a.09.09 0 0 0 .066.001l16.33-6.028.229.114V5.975a.09.09 0 0 0-.118-.085l-.383.125.238-.08a.09.09 0 0 0 0-.17L15.684.31a.09.09 0 0 0-.055 0L.236 4.956ZM29.63 9.862l-11.89 4.323v3.478l11.89-4.444V9.862Zm0 7-11.89 4.323v3.478l11.89-4.444v-3.357ZM2.37 13.276V9.918L13 14.032v3.473L2.37 13.276Zm0 7v-3.358L13 21.032v3.473L2.37 20.276ZM15.618 2.3 2.8 6.17l12.818 5.13 13.364-4.459L15.618 2.3Z`]
    } as any,
    {
        prefix: 'workspace',
        iconName: 'technicalClient',
        icon: [
            30,
            30,
            [],
            'U+E002',
            `M17 0H4a2 2 0 0 0-2 2v9.383a1.418 1.418 0 0 1 1.58-.263 1.42 1.42 0 0 0 1.759-.471c.173-.247.406-.418.661-.513V9h15v2H10.205a1.421 1.421 0 0 1 1.226 1.281 1.42 1.42 0 0 0 1.288 1.287c.77.07 1.302.723 1.294 1.432H21v2h-6.989a1.4 1.4 0 0 0 .34.338 1.42 1.42 0 0 1 0 2.323A1.42 1.42 0 0 0 13.76 21H21v2h-7.383a1.407 1.407 0 0 1-.898.431 1.42 1.42 0 0 0-1.287 1.288 1.407 1.407 0 0 1-.432.898v6.136h12.397a2 2 0 0 0 2-2V8H17.4a.4.4 0 0 1-.4-.4V0ZM9.42 11.12A1.42 1.42 0 0 1 8.016 11h1.812a1.43 1.43 0 0 0-.408.12ZM19 1.362a.4.4 0 0 1 .658-.305l5.008 4.238a.4.4 0 0 1-.258.705H19.4a.4.4 0 0 1-.4-.4V1.362ZM9 23.34a.947.947 0 0 0 .501-.748.952.952 0 0 1 .87-.855l.155-.013a.892.892 0 0 0 .723-1.29.896.896 0 0 1 .316-1.152.914.914 0 0 0 0-1.53.896.896 0 0 1-.316-1.153.892.892 0 0 0-.723-1.29l-.156-.013a.952.952 0 0 1-.869-.855.952.952 0 0 0-1.32-.783l-.132.056a1.035 1.035 0 0 1-1.226-.322 1.035 1.035 0 0 0-1.642 0 1.035 1.035 0 0 1-1.227.322l-.132-.056a.952.952 0 0 0-1.32.783.952.952 0 0 1-.868.855l-.157.013a.891.891 0 0 0-.722 1.29.896.896 0 0 1-.316 1.152.914.914 0 0 0 0 1.53c.382.248.52.746.316 1.153a.891.891 0 0 0 .722 1.29l.157.012a.952.952 0 0 1 .868.856.95.95 0 0 0 .698.826v8.184a.2.2 0 0 0 .33.151l2.44-2.11a.2.2 0 0 1 .26 0l2.44 2.11a.2.2 0 0 0 .33-.15V23.34Zm.15-4.509c0 1.657-1.384 3-3.092 3-1.707 0-3.092-1.343-3.092-3 0-1.656 1.385-3 3.092-3 1.708 0 3.092 1.344 3.092 3Z`]
    } as any,
    {
        prefix: 'workspace',
        iconName: 'alias',
        icon: [
            30,
            30,
            [],
            'U+E002',
            `M22 0a1 1 0 0 1 1 1v7.29s-.257.69-1.457.69c-1.2 0-1.4-.69-1.4-.69V3H3v20h8s1 .293 1 1.5-1 1.5-1 1.5H0a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h22Zm-8 31a1 1 0 0 1-1-1v-7s0-1 1.5-1 1.5 1 1.5 1v5h13V13.125H16v1.169s-.504.706-1.5.706-1.5-.706-1.5-.706V11a1 1 0 0 1 1-1h17a1 1 0 0 1 1 1v19a1 1 0 0 1-1 1H14Zm13.09-11.855a1 1 0 0 1 0 1.71l-7.072 4.287a1 1 0 0 1-1.518-.855v-3.288c-1.42-.013-5.568-.288-8.5-2.885-3.314-2.935-3.897-7.849-3.986-8.909A.19.19 0 0 1 6.21 9h3.528a.21.21 0 0 1 .203.253c-.216.992-.812 4.667 1.56 6.942 2.395 2.298 5.746 2.15 7 1.997v-2.479a1 1 0 0 1 1.518-.855l7.071 4.287Z`]
    } as any,
    {
        prefix: 'workspace',
        iconName: 'rtd',
        icon: [
            30,
            30,
            [],
            'U+E002',
            `M23 2H2v22h2v2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h21a2 2 0 0 1 2 2v2h-2V2Zm5 5H7v22h21V7ZM7 5a2 2 0 0 0-2 2v22a2 2 0 0 0 2 2h21a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H7Zm5 5h13v6H10v-6h2Zm0 2h11v2H12v-2Zm13 6h-5v2h5v-2Zm-15 0h8v8h-8v-8Zm6 6v-4h-4v4h4Zm4-3h5v2h-5v-2Zm5 3h-5v2h5v-2Z`]
    } as any,
    {
        prefix: 'workspace',
        iconName: 'webhook',
        icon: [
            30,
            30,
            [],
            'U+E002',
            `M23.434 9.086a6.967 6.967 0 0 1-.81 3.78l-1.915-.681a5 5 0 1 0-5.35 2.26l-.789 1.366.003.001-3.781 6.487a3 3 0 1 1-1.69-1.077l3.395-5.881a7 7 0 1 1 10.937-6.255Zm-1.657 21.01a6.967 6.967 0 0 1-2.834-2.629l1.564-1.298a5 5 0 1 0 .793-5.753l-.771-1.376-.003.002-3.642-6.566a3 3 0 1 1 1.79-.902l3.319 5.924a7 7 0 1 1-.215 12.598ZM8.185 17.139a7 7 0 1 0 7.207 7.532h6.791a3 3 0 1 0 .088-2.002l-7.508-.031v.002h-1.578a5.002 5.002 0 0 1-8.921 4.286 5 5 0 0 1 4.29-7.788l-.369-2Z`]
    } as any,
    {
        prefix: 'workspace',
        iconName: 'serviceMetadata',
        icon: [
            30,
            30,
            [],
            'U+E002',
            `M6.774 2.228A2.5 2.5 0 0 1 8.927 1h14.825a2.5 2.5 0 0 1 2.233 1.377l1.84 3.66.002-.002L30.74 11.7l-.028.015c.185.39.288.825.288 1.285v1c0 .184-.017.364-.048.539A1.972 1.972 0 0 0 29 13.957V13a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h10.688a1.958 1.958 0 0 0-.052 1.68l.241.569c.25.59.196 1.232-.092 1.751H4a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h7.932a1.97 1.97 0 0 0 1.25 1.837l.604.244A2 2 0 0 1 15.036 26H4a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h10.706c.443.826 1.45 1.326 2.48.937l1.012-.384a2 2 0 0 1 2.53 1.046l.181.401H4a3 3 0 0 1-3-3v-1a3 3 0 0 1 3-3 3 3 0 0 1-3-3v-1a3 3 0 0 1 3-3 3 3 0 0 1-3-3v-1c0-.465.106-.906.295-1.299a.614.614 0 0 1 .075-.204l1.677-2.896c.05-.126.11-.25.182-.373L4.9 5.4l1.067-1.843a.5.5 0 0 1 .08-.103l.009-.01.718-1.216ZM28 31h-2.947l.181-.401a2 2 0 0 1 2.53-1.046l1.013.384c.556.21 1.105.16 1.562-.059A2.994 2.994 0 0 1 28 31Zm-5.318-12.024a3 3 0 1 0 2.63 1.12l-.867-.594a2.992 2.992 0 0 0-1.763-.526Zm-.87-5.108c.338-1.148 1.964-1.148 2.302 0l.495 1.68a1.2 1.2 0 0 0 1.725.715l1.539-.838c1.05-.572 2.2.577 1.628 1.628l-.838 1.538a1.2 1.2 0 0 0 .714 1.726l1.68.495c1.148.338 1.148 1.964 0 2.302l-1.68.495a1.2 1.2 0 0 0-.714 1.725l.838 1.539c.572 1.05-.577 2.2-1.628 1.628l-1.539-.838a1.2 1.2 0 0 0-1.725.714l-.495 1.68c-.338 1.148-1.964 1.148-2.302 0l-.495-1.68a1.2 1.2 0 0 0-1.726-.714l-1.538.838c-1.05.572-2.2-.577-1.628-1.628l.838-1.539a1.2 1.2 0 0 0-.714-1.725l-1.68-.495c-1.149-.338-1.149-1.964 0-2.302l1.68-.495a1.2 1.2 0 0 0 .714-1.726l-.838-1.538c-.572-1.05.577-2.2 1.628-1.628l1.538.838a1.2 1.2 0 0 0 1.726-.714l.495-1.68Z`]
    } as any,
    {
        prefix: 'workspace',
        iconName: 'parentDetails',
        icon: [
            30,
            30,
            [],
            'U+E002',
            `M11.698 0H15v7.6c0 .22.18.4.4.4h7.997v5.316A7.962 7.962 0 0 0 19 12v-1H4v2h11.124a8.03 8.03 0 0 0-3.543 4H4v2h7.062a8.069 8.069 0 0 0 .52 4H4v2h8.755a7.985 7.985 0 0 0 7.34 2.926l2.352 3.529a1.99 1.99 0 0 1-1.05.298H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h9.698Zm5.96 1.057a.4.4 0 0 0-.658.305V5.6c0 .22.18.4.4.4h5.008a.4.4 0 0 0 .258-.705l-5.008-4.238Zm1.299 24.856c.729 0 1.427-.13 2.072-.37a1 1 0 0 0 .097.183l3.011 4.519a1 1 0 0 0 1.387.277l.811-.54a1 1 0 0 0 .278-1.387l-3.012-4.52a1.004 1.004 0 0 0-.166-.19 5.957 5.957 0 1 0-4.478 2.03Zm0-1.191a4.765 4.765 0 1 0 0-9.53 4.765 4.765 0 0 0 0 9.53Z`]
    } as any,
    {
        prefix: 'workspace',
        iconName: 'sunEmpty',
        icon: [
            16,
            16,
            [],
            'U+E002',
            `M7.7 1.65a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0Zm.8 13.55c3.314 0 5.7-2.386 5.7-5.7s-2.386-5.7-5.7-5.7-5.7 2.386-5.7 5.7 2.386 5.7 5.7 5.7Zm0-1.3a4.4 4.4 0 1 0 0-8.8 4.4 4.4 0 0 0 0 8.8Zm-.05 2.6a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5ZM2.2 14.75a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0ZM2.95 3a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5ZM0 9.25a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0ZM14.05 14a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5ZM13.3 3.75a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0Zm2.95 4.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Z`]
    } as any,
    {
        prefix: 'workspace',
        iconName: 'sunFull',
        icon: [
            16,
            16,
            [],
            'U+E002',
            `M7.7 1.65a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0Zm6.5 7.85c0 3.314-2.386 5.7-5.7 5.7s-5.7-2.386-5.7-5.7 2.386-5.7 5.7-5.7 5.7 2.386 5.7 5.7Zm-5.75 7a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5ZM2.2 14.75a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0ZM2.95 3a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5ZM0 9.25a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0ZM14.05 14a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5ZM13.3 3.75a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0Zm2.95 4.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Z`]
    } as any,
    {
        prefix: 'workspace',
        iconName: 'moonEmpty',
        icon: [
            16,
            16,
            [],
            'U+E002',
            `M14.5 11c.318 0 .632-.019.94-.055A8.003 8.003 0 0 1 0 8 8 8 0 0 1 7.06.055 8 8 0 0 0 14.5 11ZM12 12c.45.06.872.087 1.266.085C12.041 13.541 10.053 14.5 8 14.5c-3.335 0-6.5-3.421-6.5-6.5 0-2.35 1.423-4.738 3.58-5.736-.055.38-.08.792-.08 1.236 0 3.464 2.633 7.92 7 8.5Z`]
    } as any,
    {
        prefix: 'workspace',
        iconName: 'moonFull',
        icon: [
            16,
            16,
            [],
            'U+E002',
            `M15.44 10.945A8 8 0 0 1 7.06.055a8.001 8.001 0 1 0 8.38 10.89Z`]
    } as any,
    {
        prefix: 'workspace',
        iconName: 'hcbEmpty',
        icon: [
            16,
            16,
            [],
            'U+E002',
            `M8.75 17.5c5.087 0 8.75-3.663 8.75-8.75S13.837 0 8.75 0 0 3.663 0 8.75s3.663 8.75 8.75 8.75Zm0-1.544A7.206 7.206 0 1 0 7.186 1.714l1.748 1.05v1.841L5.298 2.423a7.246 7.246 0 0 0-1.184.81l4.82 3.214V8.29L2.965 4.452a7.206 7.206 0 0 0-.679 1.11l6.648 4.57v1.842L1.72 7.164A7.221 7.221 0 0 0 1.546 8.6l7.388 5.216v1.842L1.89 10.962a7.209 7.209 0 0 0 6.86 4.994Z`]
    } as any,
    {
        prefix: 'workspace',
        iconName: 'hcbFull',
        icon: [
            16,
            16,
            [],
            'U+E002',
            `M17.5 8.75c0 5.087-3.663 8.75-8.75 8.75S0 13.837 0 8.75 3.663 0 8.75 0s8.75 3.663 8.75 8.75ZM9 15.952A7.206 7.206 0 0 0 9 1.548v14.404Z`]
    } as any,
    {
        prefix: 'workspace',
        iconName: 'referencesIn',
        icon: [
            11,
            11,
            [],
            'U+E002',
            `M7.99 4.711v2.804a.3.3 0 0 0 .512.212l3.285-3.276a.3.3 0 0 0 0-.425L8.502.749a.3.3 0 0 0-.511.212v2.695l-2.935.013a6.491 6.491 0 0 1-1.209-.652c-.589-.394-1.124-1.11-1.524-1.765A11.389 11.389 0 0 1 1.711.1L1.704.084 1.702.08l-.367.158a968.706 968.706 0 0 0-.367.16V.4l.003.006.01.02L1 .47l.015.033a12.19 12.19 0 0 0 .624 1.165c.412.676 1.018 1.513 1.753 2.008L0 3.691v1.02h3.736a7.73 7.73 0 0 0-.319.22c-.738.533-1.353 1.459-1.77 2.205a14.15 14.15 0 0 0-.672 1.372l-.01.023-.002.006v.002a91.173 91.173 0 0 0 .737.287v-.001l.002-.005.007-.018a6.597 6.597 0 0 1 .032-.076c.029-.066.071-.163.126-.283.11-.24.27-.568.47-.925.41-.73.951-1.517 1.534-1.938.63-.455 1.125-.682 1.45-.795.097-.034.18-.057.246-.074H7.99Z`
        ]
    },
    {
        prefix: 'workspace',
        iconName: 'referencesOut',
        icon: [
            11,
            11,
            [],
            'U+E002',
            `M7.165.273a.2.2 0 0 0-.257-.159L4.64.822a.2.2 0 0 0-.043.362l1.004.605c-.075.14-.16.295-.253.454-.386.661-.868 1.35-1.325 1.68a6.87 6.87 0 0 1-1.193.706c-.11.05-.199.084-.263.106H0v.863l2.523-.011v.007h.004l.06.009c.06.01.156.03.286.073.26.083.657.252 1.164.592.216.144.458.394.705.713.244.315.478.675.682 1.02l.133.23-1.16.692a.2.2 0 0 0 .045.364l2.152.64a.2.2 0 0 0 .252-.152l.461-2.197a.2.2 0 0 0-.298-.213l-.764.456-.133-.228a10.882 10.882 0 0 0-.737-1.102c-.268-.345-.571-.673-.893-.888l-.036-.024 3.246-.014v1.662a.2.2 0 0 0 .335.147l2.237-2.06a.2.2 0 0 0 0-.294L8.027 2.96a.2.2 0 0 0-.335.147v1.628H4.243a9.77 9.77 0 0 0 .234-.164c.612-.441 1.169-1.27 1.555-1.933.09-.154.173-.303.247-.44l.954.574a.2.2 0 0 0 .301-.203L7.164.273Z`
        ]
    },
    {
        prefix: 'workspace',
        iconName: 'referencesLocate',
        icon: [
            11,
            11,
            [],
            'U+E002',
            `M3.963 0C1.774 0 0 1.99 0 4.445c0 1.984 2.59 6.042 3.583 7.355a.506.506 0 0 0 .17.148.451.451 0 0 0 .42 0 .506.506 0 0 0 .17-.148c.993-1.313 3.584-5.37 3.584-7.355C7.927 1.99 6.152 0 3.963 0ZM3.93 5.284a1.651 1.651 0 1 0 0-3.303 1.651 1.651 0 0 0 0 3.303Z`
        ]
    },
    {
        prefix: 'workspace',
        iconName: 'zoomIn',
        icon: [
            25,
            25,
            [],
            'U+E002',
            `M15.027 19.977A10.458 10.458 0 0 1 10.5 21C4.701 21 0 16.299 0 10.5S4.701 0 10.5 0 21 4.701 21 10.5c0 2.765-1.069 5.28-2.816 7.155l6.278 7.588a1 1 0 0 1-.133 1.408l-1.474 1.219a1 1 0 0 1-1.408-.133l-6.42-7.76ZM19 10.5a8.5 8.5 0 1 1-17 0 8.5 8.5 0 0 1 17 0Zm-8.53-5.37a1 1 0 0 1 1 1v3.414h3.414a1 1 0 0 1 1 1v.09a1 1 0 0 1-1 1H11.47v3.415a1 1 0 0 1-1 1h-.09a1 1 0 0 1-1-1v-3.414H5.966a1 1 0 0 1-1-1v-.09a1 1 0 0 1 1-1H9.38V6.13a1 1 0 0 1 1-1h.09Z`
        ]
    } as any,
    {
        prefix: 'workspace',
        iconName: 'zoomOut',
        icon: [
            25,
            25,
            [],
            'U+E002',
            `M15.027 19.977A10.458 10.458 0 0 1 10.5 21C4.701 21 0 16.299 0 10.5S4.701 0 10.5 0 21 4.701 21 10.5c0 2.765-1.069 5.28-2.816 7.155l6.278 7.588a1 1 0 0 1-.133 1.408l-1.474 1.219a1 1 0 0 1-1.408-.133l-6.42-7.76ZM19 10.5a8.5 8.5 0 1 1-17 0 8.5 8.5 0 0 1 17 0Zm-14.034 0a1 1 0 0 1 1.008-.992l8.918.073a1 1 0 0 1 .992 1.008v.09a1 1 0 0 1-1.009.992l-8.918-.073a1 1 0 0 1-.991-1.008v-.09Z`
        ]
    } as any,
    {
        prefix: 'workspace',
        iconName: 'expand',
        icon: [
            26,
            26,
            [],
            'U+E002',
            `M10.584 9.795a.7.7 0 0 0 0-.99L4.28 2.5H9.3a.7.7 0 0 0 .7-.7V.7a.7.7 0 0 0-.7-.7H.7a.7.7 0 0 0-.7.7v8.6a.7.7 0 0 0 .7.7h1.1a.7.7 0 0 0 .7-.7V4.256l6.317 6.317a.7.7 0 0 0 .99 0l.777-.778Zm4.832 6.41a.7.7 0 0 0 0 .99L21.72 23.5H16.7a.7.7 0 0 0-.7.7v1.1a.7.7 0 0 0 .7.7h8.6a.7.7 0 0 0 .7-.7v-8.6a.7.7 0 0 0-.7-.7h-1.1a.7.7 0 0 0-.7.7v5.044l-6.317-6.317a.7.7 0 0 0-.99 0l-.777.778Zm1.779-5.62a.7.7 0 0 1-.99 0l-.778-.778a.7.7 0 0 1 0-.99L21.744 2.5H16.7a.7.7 0 0 1-.7-.7V.7a.7.7 0 0 1 .7-.7h8.6a.7.7 0 0 1 .7.7v8.6a.7.7 0 0 1-.7.7h-1.1a.7.7 0 0 1-.7-.7V4.28l-6.305 6.304Zm-7.4 4.83a.7.7 0 0 0-.99 0L2.5 21.722V16.7a.7.7 0 0 0-.7-.7H.7a.7.7 0 0 0-.7.7v8.6a.7.7 0 0 0 .7.7h8.6a.7.7 0 0 0 .7-.7v-1.1a.7.7 0 0 0-.7-.7H4.256l6.317-6.317a.7.7 0 0 0 0-.99l-.778-.777Z`
        ]
    },
    {
        prefix: 'workspace',
        iconName: 'collapse',
        icon: [
            28,
            28,
            [],
            'U+E002',
            `M25.805.416a.7.7 0 0 1 .99 0l.778.777a.7.7 0 0 1 0 .99L21.256 8.5H26.3a.7.7 0 0 1 .7.7v1.1a.7.7 0 0 1-.7.7h-8.6a.7.7 0 0 1-.7-.7V1.7a.7.7 0 0 1 .7-.7h1.1a.7.7 0 0 1 .7.7v5.02L25.805.417Zm-25.39.789a.7.7 0 0 0 0 .99L6.722 8.5H1.7a.7.7 0 0 0-.7.7v1.1a.7.7 0 0 0 .7.7h8.6a.7.7 0 0 0 .7-.7V1.7a.7.7 0 0 0-.7-.7H9.2a.7.7 0 0 0-.7.7v5.044L2.182.427a.7.7 0 0 0-.99 0l-.777.778Zm27.17 25.59a.7.7 0 0 0 0-.99L21.278 19.5H26.3a.7.7 0 0 0 .7-.7v-1.1a.7.7 0 0 0-.7-.7h-8.6a.7.7 0 0 0-.7.7v8.6a.7.7 0 0 0 .7.7h1.1a.7.7 0 0 0 .7-.7v-5.044l6.317 6.317a.7.7 0 0 0 .99 0l.777-.778Zm-26.38.79a.7.7 0 0 0 .99 0L8.5 21.278V26.3a.7.7 0 0 0 .7.7h1.1a.7.7 0 0 0 .7-.7v-8.6a.7.7 0 0 0-.7-.7H1.7a.7.7 0 0 0-.7.7v1.1a.7.7 0 0 0 .7.7h5.044L.427 25.817a.7.7 0 0 0 0 .99l.778.777Z`
        ]
    },
    {
        prefix: 'workspace',
        iconName: 'filterSettings',
        icon: [
            30,
            30,
            [],
            'U+E002',
            `M.712 4.933C-.932 2.983.455 0 3.006 0h24.092c2.552 0 3.939 2.984 2.293 4.935L22.586 13h-1.388a1 1 0 0 0-.985.828l-.192 1.099a7.856 7.856 0 0 0-1.51.94l-1.176-.42a1 1 0 0 0-1.192.424l-1.73 2.863a1 1 0 0 0 .18 1.253l1.016.935a7.914 7.914 0 0 0-.072 1.347l-.842.705a1 1 0 0 0-.227 1.26l1.38 2.43a2.091 2.091 0 0 1-.22-.147l-3.578-2.736a2 2 0 0 1-.785-1.589v-3.656a2 2 0 0 0-.441-1.254L4.653 9.61.712 4.933ZM23.588 15.5a1 1 0 0 0-.986.836l-.223 1.335a5.43 5.43 0 0 0-1.28.768l-1.27-.505a1 1 0 0 0-1.224.413l-.923 1.526a1 1 0 0 0 .206 1.277l1.205 1.033a5.481 5.481 0 0 0 .012 1.093l-1.186.962a1 1 0 0 0-.239 1.27l.881 1.551a1 1 0 0 0 1.214.445l1.42-.52c.362.277.76.51 1.184.691l.223 1.336a1 1 0 0 0 .986.835h1.784a1 1 0 0 0 .986-.835l.219-1.312a5.43 5.43 0 0 0 1.209-.693l1.475.515a1 1 0 0 0 1.207-.463l.856-1.565a1 1 0 0 0-.259-1.266l-1.162-.914a5.47 5.47 0 0 0 .012-1.162l1.178-.956a1 1 0 0 0 .239-1.27l-.881-1.551a1 1 0 0 0-1.214-.445l-1.345.493a5.43 5.43 0 0 0-1.315-.774l-.219-1.312a1 1 0 0 0-.986-.836h-1.784Zm3.309 7.173a2.391 2.391 0 1 1-4.782 0 2.391 2.391 0 0 1 4.782 0Z`,
        ]
    },
    {
        prefix: 'workspace',
        iconName: 'cad',
        icon: [
            22,
            22,
            [],
            'U+E002',
            `m16.516 20.583-.209.172H6.486a5.46 5.46 0 0 1-3.346-1.139C1.25 18.496 0 16.55 0 14.336c0-2.6 1.726-4.833 4.188-5.79a7.326 7.326 0 0 1-.028-.647C4.16 3.537 8.028 0 12.8 0c3.022 0 5.681 1.418 7.225 3.566a5.143 5.143 0 0 1 2.215-.494c2.65 0 4.8 1.965 4.8 4.389 0 .547-.11 1.07-.31 1.553 1.957.32 3.605 1.45 4.514 2.999a.796.796 0 0 0-.263.052l-1.05.402a8.428 8.428 0 0 0-1.965-1.106l-.212-1.057a1 1 0 0 0-.98-.804H22.74a1 1 0 0 0-.986.836l-.182 1.09c-.672.284-1.3.651-1.87 1.09l-1.32-.422a1 1 0 0 0-1.174.458l-2.078 3.655a1 1 0 0 0 .206 1.243l1.104.977a8.552 8.552 0 0 0 .075 2.156ZM23.996 12a1 1 0 0 0-.987.836l-.223 1.335a5.434 5.434 0 0 0-1.201.706l-1.279-.47a1 1 0 0 0-1.214.445l-.881 1.55a1 1 0 0 0 .238 1.271l1.066.866a5.508 5.508 0 0 0 .005 1.304l-1.061.873a1 1 0 0 0-.23 1.272l.891 1.544a1 1 0 0 0 1.217.437l1.276-.478c.358.274.752.505 1.173.684l.223 1.336a1 1 0 0 0 .986.835h1.784a1 1 0 0 0 .986-.835l.219-1.312a5.432 5.432 0 0 0 1.24-.717l1.244.457a1 1 0 0 0 1.214-.445l.882-1.55a1 1 0 0 0-.24-1.27l-1.018-.828a5.489 5.489 0 0 0-.005-1.38l1.014-.835a1 1 0 0 0 .23-1.272l-.891-1.545a1 1 0 0 0-1.217-.436l-1.24.465a5.426 5.426 0 0 0-1.213-.695l-.219-1.312A1 1 0 0 0 25.78 12h-1.784Zm3.308 7.173a2.391 2.391 0 1 1-4.782 0 2.391 2.391 0 0 1 4.782 0Z`,
        ]
    } as any,
    {
        prefix: 'workspace',
        iconName: 'analyzer',
        icon: [
            31,
            20,
            [],
            'U+E002',
            `M2.5 0A2.5 2.5 0 0 0 0 2.5v11A2.5 2.5 0 0 0 2.5 16h19.612a4.495 4.495 0 0 0 2.957 1.104 4.5 4.5 0 0 0 1.957-.445.843.843 0 0 0 .083.12l2.403 2.904a.84.84 0 1 0 1.295-1.072l-2.402-2.904a.853.853 0 0 0-.035-.04A4.512 4.512 0 0 0 25 8.08V2.5A2.5 2.5 0 0 0 22.5 0h-20Zm21 8.36V2.5a1 1 0 0 0-1-1h-20a1 1 0 0 0-1 1v5.207h5.534l1.306 1.92 3.48-6.037 2.902 4.117h5.834v1.646h-6.995l-1.624-2.47-3.482 6.038-2.437-3.568H1.5V13.5a.997.997 0 0 0 1 1h18.479A4.514 4.514 0 0 1 23.5 8.36Zm4.9 4.19a3.35 3.35 0 1 1-6.7 0 3.35 3.35 0 0 1 6.7 0Z`,
        ]
    } as any,
    {
        prefix: 'workspace',
        iconName: 'triangle',
        icon: [
            17,
            12,
            [],
            'U+E002',
            `M9.721 11.288a1.5 1.5 0 0 1-2.442 0L1.098 2.62C.39 1.628 1.099.25 2.318.25h12.363c1.22 0 1.93 1.378 1.221 2.371l-6.18 8.667Z`,
        ]
    } as any,
    {
        prefix: 'workspace',
        iconName: 'editYaml',
        icon: [
            32,
            32,
            [],
            'U+E002',
            `M16.698 0H20v7.6c0 .22.18.4.4.4h7.997v21.753a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h9.698Zm9.496 20.545-3.282-2.554-6.472 8.029a4 4 0 0 0-.856 2.022l-.312 2.535a.3.3 0 0 0 .425.308l2.53-1.18a4 4 0 0 0 1.412-1.1l6.555-8.06ZM23.5 17.368l3.234 2.53 1.117-1.428a.5.5 0 0 0-.086-.702l-2.446-1.914a.5.5 0 0 0-.702.086L23.5 17.368Zm-12.196-6.913H7.376l5.32 9.687V25h3.494v-4.858l5.32-9.687h-3.928l-3.075 6.086h-.128l-3.075-6.086Z`,
        ]
    } as any,
    {
        prefix: 'workspace',
        iconName: 'collapseItem',
        icon: [
            24,
            32,
            [],
            'U+E002',
            `M10.671 12.899c1.148 1.02 3.008 1.02 4.156 0l8.816-7.837c1.148-1.02 1.361-2.163.361-3.398-1.148-1.02-2.369-1.316-3.517-.296l-7.738 6.99-7.738-6.99c-1.007-.97-2.36-.724-3.507.296-1 1.235-.797 2.378.35 3.398l8.817 7.837Zm4.301 6.866c-1.147-1.02-3.008-1.02-4.156 0L2 27.602C.852 28.622.64 29.765 1.64 31c1.147 1.02 2.368 1.316 3.516.296l7.738-6.99 7.739 6.99c1.006.97 2.359.724 3.506-.296 1-1.235.797-2.378-.35-3.398l-8.817-7.837Z`
        ]
    } as any,
    {
        prefix: 'workspace',
        iconName: 'expandItem',
        icon: [
            24,
            32,
            [],
            'U+E002',
            `M14.833 1.5c-1.148-1.02-3.008-1.02-4.156 0L1.861 9.337C.713 10.357.5 11.5 1.5 12.735c1.148 1.02 2.37 1.316 3.517.296l7.738-6.99 7.738 6.99c1.007.969 2.36.724 3.507-.296 1-1.235.797-2.378-.35-3.398L14.832 1.5ZM10.81 31.164c1.148 1.02 3.009 1.02 4.156 0l8.817-7.837c1.147-1.02 1.36-2.163.36-3.398-1.147-1.02-2.369-1.316-3.516-.296l-7.739 6.99-7.738-6.99c-1.007-.969-2.359-.724-3.507.296-1 1.235-.797 2.378.351 3.398l8.816 7.837Z`
        ]
    } as any
];



